"use client";

import { useEffect, useMemo, useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { useChatInterface } from "@/hooks/use-chat-interface";

type ChatSession = { title?: string } | null;

export function ChatTitle() {
  const { chatId } = useChatInterface();
  const [session, setSession] = useState<ChatSession>(null);

  const displayTitle = useMemo(() => {
    if (!session?.title) return null;
    return session.title;
  }, [session]);

  useEffect(() => {
    let isMounted = true;
    const load = async () => {
      if (!chatId) {
        setSession(null);
        return;
      }
      try {
        const res = await fetch(`/api/chats/${chatId}`, { cache: "no-store" });
        if (!res.ok) return;
        const data = (await res.json()) as { title?: string };
        if (isMounted) setSession(data);
      } catch {
        // ignore
      }
    };
    load();
    return () => {
      isMounted = false;
    };
  }, [chatId]);

  return (
    <AnimatePresence mode="wait">
      {displayTitle && (
        <motion.div
          key={displayTitle}
          initial={{ width: 0, opacity: 0 }}
          animate={{ width: "auto", opacity: 1 }}
          exit={{ width: 0, opacity: 0 }}
          transition={{ duration: 0.2, ease: "easeOut" }}
          className="overflow-hidden"
        >
          <div className="text-sm font-bold text-[var(--mindup-plum)] dark:text-[var(--mindup-pink)] whitespace-nowrap">
            {displayTitle}
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
